/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FileProcessStatus = {
    LogIdNotFound: 'LogIdNotFound',
    AlreadyProcessed: 'AlreadyProcessed',
    S3FileNotFound: 'S3FileNotFound',
    NoParsersRegisteredForTarget: 'NoParsersRegisteredForTarget',
    ParsingValidationErrors: 'ParsingValidationErrors',
    CalculationErrors: 'CalculationErrors',
    UnExpectedError: 'UnExpectedError',
    Completed: 'Completed'
} as const;
export type FileProcessStatus = typeof FileProcessStatus[keyof typeof FileProcessStatus];


export function instanceOfFileProcessStatus(value: any): boolean {
    for (const key in FileProcessStatus) {
        if (Object.prototype.hasOwnProperty.call(FileProcessStatus, key)) {
            if (FileProcessStatus[key as keyof typeof FileProcessStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FileProcessStatusFromJSON(json: any): FileProcessStatus {
    return FileProcessStatusFromJSONTyped(json, false);
}

export function FileProcessStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileProcessStatus {
    return json as FileProcessStatus;
}

export function FileProcessStatusToJSON(value?: FileProcessStatus | null): any {
    return value as any;
}

export function FileProcessStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FileProcessStatus {
    return value as FileProcessStatus;
}

